import React from "react"
import { graphql, Link } from "gatsby"
import SEO from "../components/SEO"
import Layout from "../components/Layout"
import { H1, H2 } from "../components/atoms/Headings"
import { Padding } from "styled-components-spacing/dist/cjs"
import { Container } from "../components/Container"

const LinkResolver = require("../utils/linkResolver")

const TemplateEcosystemPageTemplate = ({ data, pageContext }) => {
  const seoNode = {
    title: `Templates related to ${pageContext.ecosystem}`,
    pagePath: LinkResolver("TemplateEcoSystem", pageContext.ecosystem),
  }

  return (
    <Layout>
      <SEO {...seoNode} />
      <Container>
        <div>
          <H1>{pageContext.ecosystem}</H1>

          <div>
            <H2>Templates related to {pageContext.ecosystem}</H2>

            {data.allContentfulTemplate.nodes.map(template => (
              <Padding vertical={2} key={template.slug}>
                <Link to={LinkResolver(template.internal.type, template.slug)}>
                  {template.title}
                </Link>
              </Padding>
            ))}
          </div>
        </div>
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query ($ecosystem: String!) {
    allContentfulTemplate(
      filter: { ecosystem: { eq: $ecosystem }, title: { ne: "__schema__" } }
      sort: { fields: title }
    ) {
      nodes {
        title
        slug
        internal {
          type
        }
      }
    }
  }
`

export default TemplateEcosystemPageTemplate
